import React, { useRef } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { Transition } from 'react-transition-group';
import cn from 'classnames';

import { Icon } from 'components';

import arrowDown from 'assets/svg/arrow-left.svg';
import './collapsibleSettingsRow.scss';

interface Props {
    onToggle: () => void;
    isOpen: boolean;
    title: string | JSX.Element;
    message: MessageDescriptor;
}

const CollapsibleSettingsRow: React.FC<Props> = ({
    isOpen,
    title,
    onToggle,
    message,
    children,
}) => {
    const transitionRef = useRef<HTMLDivElement>(null);

    return (
        <React.Fragment>
            <div styleName="container " onClick={onToggle}>
                <div styleName="title">{title}</div>
                <div styleName="selected-item">
                    <FormattedMessage {...message} />
                </div>
                <div styleName="toggle">
                    <Icon
                        styleName={cn('icon ', {
                            'is-open': isOpen,
                        })}
                        glyph={arrowDown}
                    />
                </div>
            </div>

            <Transition in={isOpen} timeout={300}>
                {transition => {
                    if (transition === 'exited') {
                        return null;
                    }

                    return (
                        <div
                            ref={transitionRef}
                            styleName="transition-animation"
                            style={{
                                height:
                                    transition === 'entered'
                                        ? transitionRef.current?.scrollHeight
                                        : 0,
                            }}
                        >
                            {children}
                        </div>
                    );
                }}
            </Transition>
        </React.Fragment>
    );
};

export default CollapsibleSettingsRow;
